import React, {useState} from 'react';

export function CollapsibleSection({header, content, isOpenByDefault = false}) {
    const [isOpen, setIsOpen] = useState(isOpenByDefault);

    const toggleSection = () => {
        setIsOpen(!isOpen);
    }

    return (
        <div className={"page-section"}>
            <div className="collapsible-section">
                <div className="header" onClick={toggleSection}>
                    <h3>{header}</h3>
                    <span className={isOpen ? "icon-minus" : "icon-plus"}></span>
                </div>
                {isOpen && (

                    <div className="content">
                        {content}
                    </div>

                )}
            </div>
        </div>
    );
}
